import type { StyleRule } from '@archipro-design/aria';
import { pxToRem, pxArrayToRem } from '@archipro-design/aria';
import {
    boxClassName,
    captionClassName,
    videoPlayerClassName,
} from '@archipro-design/aria';
import type { ColumnDimensionType } from '@modules/page-builder/types';
import {
    PADDING_LEFT_RIGHT_SECTION_MOBILE,
    PADDING_LEFT_RIGHT_SECTION,
} from '../../common/pagebuilder.style';

export const SingleVideoModule: StyleRule<{
    isSingleVideoParagraphModule?: boolean;
}> = ({ theme, isSingleVideoParagraphModule }) => ({
    margin: '0 auto',
    width: '100%',

    padding: pxArrayToRem([0, PADDING_LEFT_RIGHT_SECTION_MOBILE]),

    [theme.screen.laptop]: {
        padding: pxArrayToRem([0, PADDING_LEFT_RIGHT_SECTION]),

        ...(isSingleVideoParagraphModule && {
            padding: '0 !important',
        }),
    },
});

export const AspectRatioBox: StyleRule<{
    dimension?: ColumnDimensionType;
    isSingleVideoParagraphModule?: boolean;
}> = ({ theme, dimension, isSingleVideoParagraphModule }) => ({
    position: 'relative',
    height: dimension?.mobileHeight ? pxToRem(dimension.mobileHeight) : '100%',
    width: '100%',
    margin: isSingleVideoParagraphModule ? '0' : '0 auto', // Left align for video paragraph module

    [theme.screen.laptop]: {
        overflow: 'hidden',
        ...(isSingleVideoParagraphModule && {
            maxWidth: '100%',
            width: pxToRem(1050), // Always 1050px width for video paragraph module (like landscape images)
            aspectRatio: '16/9', // Standard landscape video aspect ratio
            height: 'auto', // Let aspect ratio determine height
        }),

        ...(!isSingleVideoParagraphModule && {
            height: dimension?.height ? pxToRem(dimension.height) : '100%',
        }),
    },

    [`& .${videoPlayerClassName}`]: {
        width: '100%',
        height: '100%',

        [`& .${boxClassName}`]: {
            position: 'absolute',
        },
    },
});

export const CaptionVideo: StyleRule<{
    dimension?: ColumnDimensionType;
    isSingleVideoParagraphModule?: boolean;
}> = ({ theme, isSingleVideoParagraphModule }) => ({
    margin: '0 auto',
    letterSpacing: '0.015em',
    width: '100%',
    fontSize: pxToRem(20),
    lineHeight: '1.2',
    color: '#161616',
    textAlign: 'left',
    overflowWrap: 'break-word',
    fontWeight: 450,

    [`& .${captionClassName}`]: {
        fontSize: pxToRem(22),
        lineHeight: '120%',
        letterSpacing: '0.015em',
        fontWeight: 450,
        color: '#161616',
        fontFamily: 'neue-haas-grotesk-display',
    },

    [theme.screen.laptop]: {
        ...(isSingleVideoParagraphModule && {
            margin: '0',
            maxWidth: '100%',
            width: pxToRem(1050), // Match the video width for video paragraph module
        }),
    },
});
